import { SimpleGrid } from "@chakra-ui/react";
import {
  ProductReviewCard,
  ProductReviewCardProps,
} from "./product-review-card";

type Props = {
  products: ProductReviewCardProps[];
};

export function ProductReviewGrid({ products }: Props) {
  return (
    <SimpleGrid
      columns={[1, 2, 3]}
      spacing="4"
      sx={{
        ".product-review-card-image": {
          height: "2xs",
        },
      }}
    >
      {products.map((product, idx) => (
        <ProductReviewCard key={idx} {...product} />
      ))}
    </SimpleGrid>
  );
}
